










import { Component, namespace, Prop, Vue } from 'nuxt-property-decorator'
import { IMobileAppList } from '~/assets/interfaces/mobile-app'
const playMarket = require('~/assets/images/mobileApps/google-play.svg')
const appStore = require('~/assets/images/mobileApps/app-store.svg')

const siteStore = namespace('site')
@Component({
  components: {
    ComponentImage: () => import('~/components/images/image.vue'),
  },
})
export default class ComponentMobileAppGet extends Vue {
  @Prop({ default: null, type: String }) private platform!: string
  @siteStore.State('mobileApp') private mobileApp!: IMobileAppList

  private get icon() {
    switch (this.platform) {
      case 'ios':
        return appStore
      case 'android':
        return playMarket
      default:
        return ''
    }
  }

  get url() {
    return this.mobileApp[this.platform]?.url || ''
  }

  private get title() {
    switch (this.platform) {
      case 'ios':
        return 'AppStore'
      case 'android':
        return 'GooglePlay'
      default:
        return ''
    }
  }

  private get aspectRatio() {
    switch (this.platform) {
      case 'ios':
        return '121/40'
      case 'android':
        return '135/40'
      default:
        return ''
    }
  }
}
